import {
  Database,
  Workflow,
  Code2,
  LayoutDashboard,
  LayoutGrid,
  ShieldCheck,
} from "lucide-react";
import { LeftPanel, type LeftPanelFeature } from "@/components/layout/left-panel";
import { DitherShader } from "@/components/landing/dither-shader";
import "./auth.css";

// Las mismas piezas que presenta la landing.
const authFeatures: LeftPanelFeature[] = [
  { icon: Database, label: "Colecciones" },
  { icon: Workflow, label: "Automatizaciones" },
  { icon: Code2, label: "Código" },
  { icon: LayoutDashboard, label: "Paneles" },
  { icon: LayoutGrid, label: "Apps" },
  { icon: ShieldCheck, label: "Seguridad" },
];

interface AuthLeftPanelProps {
  headline: string;
  subtitle: string;
  badge: string;
}

export function AuthLeftPanel({
  headline,
  subtitle,
  badge,
}: AuthLeftPanelProps) {
  return (
    <LeftPanel
      headline={headline}
      subtitle={subtitle}
      badge={badge}
      features={authFeatures}
    />
  );
}

export function AuthMobileLogo() {
  return (
    <div className="home-fonts mb-6 flex items-center justify-center gap-2.5 lg:hidden">
      <img
        src="/heskala-logo.png"
        alt=""
        aria-hidden="true"
        width={30}
        height={30}
        className="size-[30px]"
      />
      <span className="font-heading text-[24px] leading-none text-[#001434]">
        heskala
      </span>
    </div>
  );
}

export function AuthRightPanel({ children }: { children: React.ReactNode }) {
  return (
    <div className="home-fonts relative w-full min-h-screen overflow-hidden lg:overflow-visible flex items-center justify-center px-6 py-24 sm:px-8 lg:bg-transparent lg:px-0 lg:py-12 lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2 lg:flex lg:items-center lg:justify-center lg:pr-12 xl:pr-16">
      <div className="absolute inset-0 bg-white lg:hidden" aria-hidden />
      <div className="lg:hidden">
        <DitherShader
          variant="arc"
          className="absolute inset-x-0 -bottom-10 h-[360px]"
        />
      </div>
      <div
        className="auth-card relative z-10 w-full max-w-md rounded-md border border-[#C9D6EA] bg-white p-6 text-[#001434] shadow-[0_24px_60px_-24px_rgba(0,20,52,0.35)] sm:p-8"
      >
        {children}
      </div>
    </div>
  );
}
